import { FC } from "react";
import { CuToman, Delete, Edit, Package } from "@payping/icons";
import { Flex, Image, Typography } from "@payping/web-components";
import { formatLocalizedNumber } from "@payping/utilities-shared/number";

import listStyles from "@/assets/scss/Shop/Invoice/scss/index.module.scss";
import { Product } from "@/pages/Shop/Invoice/forms/type";

interface Props {
  item: Product;
  onEdit(item: Product): void;
  onRemove(item: Product): void;
}

const CreateItemCard: FC<Props> = ({ item, onEdit, onRemove }) => (
  <Flex
    vertical
    className="tw-h-[180px] tw-w-full tw-overflow-hidden tw-rounded-md tw-border tw-border-solid tw-border-color-border"
  >
    <Flex className="tw-h-[calc(100%-40px)] tw-w-full">
      <Flex
        className="tw-h-full tw-w-[50%] tw-overflow-hidden tw-rounded-[0_5px_0_0]"
        style={{ backgroundColor: "#EBEEEF" }}
        justify="center"
        align="center"
      >
        {item.imageLink ? (
          <Image src={item.imageLink} className="tw-h-auto tw-w-full" />
        ) : (
          <Package className={"color--gray500 tw-h-full tw-w-full"} />
        )}
      </Flex>
      <Flex flex={1.025} className="tw-p-[10px]" style={{ backgroundColor: "#fff" }}>
        <Typography.Text className="!tw-font-semibold">{item.title}</Typography.Text>

        <div className="tw-mt-auto">
          <Flex align="center">
            <span className="tw-text-[13px]">{formatLocalizedNumber({ value: item.totalAmount ?? 0 })}</span>
            <CuToman width={24} height={24} />
          </Flex>
        </div>
      </Flex>
    </Flex>
    <Flex className="tw-h-[40px] tw-w-full tw-border-0 tw-border-t tw-border-solid tw-border-color-border">
      <Flex flex={1} justify="center" align="center" onClick={() => onEdit(item)} className="tw-cursor-pointer">
        <Edit className={listStyles.danger} width={14} />
      </Flex>
      <Flex flex={1} justify="center" align="center" onClick={() => onRemove(item)} className="tw-cursor-pointer">
        <Delete width={14} />
      </Flex>
    </Flex>
  </Flex>
);

export default CreateItemCard;
